module.exports = __webpack_public_path__ + "img/ui_rotation_0030.6426c684.png";